import React from "react";
import { Button } from "react-bootstrap";

const nomesTipos = {
  veiculo: "Veículo",
  arma_fogo: "Arma de fogo",
  arma_branca: "Arma branca",
  droga: "Droga",
  outro_objeto: "Outros objetos/bens",
};

const participacoes = {
  apreendido: "Apreendido",
  encontrado: "Encontrado",
  subtraido: "Subtraído",
  apreendido_infracao_transito: "Apreendido por infração de trânsito",
};

function resumoDoItem(item) {
  if (!item.tipoItem) {
    return {
      tipo: "Registro legado",
      identificacao: item.descricao || "Item sem descrição",
      quantidade: item.quantidade,
      participacoes: [],
    };
  }
  const chaveDados = {
    veiculo: "dadosVeiculo",
    arma_fogo: "dadosArma",
    arma_branca: "dadosArmaBranca",
    droga: "dadosDroga",
    outro_objeto: "dadosObjeto",
  }[item.tipoItem];
  const dados = item[chaveDados] || {};
  const identificacao = item.tipoItem === "veiculo"
    ? [dados.marca, dados.modelo, dados.placa && `Placa ${dados.placa}`].filter(Boolean).join(" — ")
    : item.tipoItem === "arma_fogo"
      ? [dados.especie, dados.marca, dados.calibreReal].filter(Boolean).join(" — ")
      : item.tipoItem === "arma_branca"
        ? [dados.tipoArmaBranca, dados.descricao, dados.marca].filter(Boolean).join(" — ")
      : item.tipoItem === "droga"
        ? dados.tipoDroga === "Outra droga" ? dados.substancia : dados.tipoDroga
        : dados.tipoObjeto;
  const quantidade = dados.quantidade
    ? `${dados.quantidade}${dados.unidade ? ` ${dados.unidade}` : item.tipoItem === "arma_branca" ? " unidade(s)" : ""}`
    : item.tipoItem === 'arma_fogo' ? (item.quantidade ? `${item.quantidade} arma(s)` : 'Quantidade não informada') : item.tipoItem === 'veiculo' ? '1 item' : '';
  return {
    tipo: nomesTipos[item.tipoItem] || "Item",
    identificacao: identificacao || "Sem identificação informada",
    quantidade,
    participacoes: (dados.participacoes || []).map((value) => participacoes[value] || value),
  };
}

function MaterialList({ boletim, setBoletim, onEdit, editingIndex, onEditIndex }) {
  const itens = boletim.materiaisApreendidos || [];
  if (!itens.length) return null;

  const remover = (index) => {
    if (!window.confirm("Deseja excluir este item do boletim?")) return;
    setBoletim((current) => ({
      ...current,
      materiaisApreendidos: (current.materiaisApreendidos || []).filter((_, i) => i !== index),
    }));
    if (editingIndex === index) onEditIndex(null);
    else if (editingIndex !== null && editingIndex > index) onEditIndex(editingIndex - 1);
  };

  return (
    <section className="bo-section" aria-labelledby="materiais-lista-titulo">
      <h2 className="bo-section-title" id="materiais-lista-titulo">Itens cadastrados</h2>
      <div className="material-card-list">
        {itens.map((item, index) => {
          const resumo = resumoDoItem(item);
          return (
            <article className="material-card" key={item._id || item.id || index}>
              <div className="material-card-content">
                <span className="material-card-category">{resumo.tipo}</span>
                <h3>{resumo.identificacao}</h3>
                {resumo.quantidade && <p><strong>Quantidade:</strong> {resumo.quantidade}</p>}
                {resumo.participacoes.length > 0 && (
                  <p><strong>Participação:</strong> {resumo.participacoes.join(", ")}</p>
                )}
              </div>
              <div className="material-card-actions">
                <Button
                  variant="outline-primary"
                  size="sm"
                  type="button"
                  onClick={() => onEdit(index, item)}
                  aria-label={`Editar ${resumo.identificacao}`}
                >
                  Editar
                </Button>
                <Button
                  variant="outline-danger"
                  size="sm"
                  type="button"
                  onClick={() => remover(index)}
                  aria-label={`Excluir ${resumo.identificacao}`}
                >
                  Excluir
                </Button>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}

export default MaterialList;
